module.exports = "/static/assets/b1efa4237175d3c78052aa209a7ded25.png";